import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ValueOffer() {
  return <section id="comprar" className="py-24 bg-espresso text-cream" data-id="element-212">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-213">
        <div className="border border-cream/20 p-8 md:p-16 relative overflow-hidden" data-id="element-214">
          <div className="absolute top-0 right-0 w-64 h-64 bg-terracotta/10 rounded-full blur-3xl -z-10 transform translate-x-1/2 -translate-y-1/2" data-id="element-215"></div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12" data-id="element-216">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight" data-id="element-217">
              Todo lo que necesitas para dejar de improvisar y empezar a hornear
              con seguridad
            </h2>
            <p className="text-lg text-cream/70" data-id="element-218">
              Un solo pago. Acceso inmediato. Resultados para toda la vida.
            </p>
          </motion.div>

          <div className="bg-warm-white/5 p-8 md:p-10 mb-10" data-id="element-219">
            <h3 className="font-serif text-2xl mb-6 text-terracotta" data-id="element-220">
              ¿Qué te llevas hoy?
            </h3>
            <ul className="space-y-4" data-id="element-221">
              {["Ebook digital premium 'Masa Pan' (PDF)", '12 recetas emblemáticas detalladas paso a paso', 'Guía de ingredientes y herramientas esenciales', 'Fórmulas panaderas explicadas de forma sencilla', 'Tips de horneado para hornos caseros', 'Acceso inmediato desde cualquier dispositivo', '7 días de soporte por dudas y preguntas', '¡No estarás sol@! Te acompañaré a preparar tu primera masa si se te complica'].map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-222">
                  <CheckCircle2 className="text-bakery-brown mt-0.5 flex-shrink-0" size={20} data-id="element-223" />
                  <span className="text-cream/90 text-lg" data-id="element-224">{item}</span>
                </motion.li>)}
            </ul>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="text-center" data-id="element-225">
            <div id="comprar-btn" className="mb-8" data-id="element-226">
              <span className="text-5xl font-bold text-cream" data-id="element-227">$14.99</span>
              <span className="text-cream/60 ml-2" data-id="element-228">USD</span>
            </div>
            <a href="https://theassetsvault.com/cart/53928005763382:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-terracotta text-cream px-12 py-5 text-lg font-bold tracking-wide hover:bg-cream hover:text-espresso transition-colors duration-300 shadow-xl text-center" data-id="element-229">
              Comprar Ebook Ahora
            </a>
            <p className="mt-4 text-sm text-cream/50" data-id="element-230">
              Pago seguro. Descarga inmediata.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}